import axios, { isAxiosError } from 'axios';
import { env } from '@/shared/config/env';

export const http = axios.create({ baseURL: env.apiBase, withCredentials: true, timeout: 30_000 });

export function errorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const detail: unknown = error.response?.data?.detail;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) return detail.map((d: { msg?: string }) => d.msg ?? 'Invalid input').join('. ');
    if (detail && typeof detail === 'object' && typeof (detail as { message?: unknown }).message === 'string') {
      return (detail as { message: string }).message;
    }
    if (!error.response) return 'Cannot reach the server';
  }
  return 'Something went wrong';
}

export function isUnauthorised(error: unknown): boolean {
  return isAxiosError(error) && error.response?.status === 401;
}
